<template>
  <v-container fluid class="login-page">
    <v-row justify="center" align="center" class="fill-height">
      <v-col cols="12" sm="8" md="4">
        <v-card class="pa-6 login-card" elevation="10">
          <h2 class="text-center mb-6 font-weight-bold">Welcome Back</h2>
          <v-form>
            <v-text-field
                v-model="email"
                label="Email"
                type="email"
                prepend-inner-icon="mdi-email-outline"
                outlined
                dense
                required
            />
            <v-text-field
                v-model="password"
                label="Password"
                type="password"
                prepend-inner-icon="mdi-lock-outline"
                outlined
                dense
                required
            />
            <v-btn
                color="primary"
                block
                large
                class="mt-4 login-btn"
                to="/"
            >
              Login
            </v-btn>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'LoginPage',
  data() {
    return {
      email: '',
      password: '',
    };
  },
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-card {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.login-btn {
  text-transform: uppercase;
  font-weight: bold;
  letter-spacing: 1px;
}
</style>
